import { useMutation } from "@apollo/client";

import { gql } from "~/__generated__";

import { PROJECT_USER_GET_ALL_WITH_ACCESS_TO_PROJECT } from "./useProjectUserGetAllWithAccessToProject";

const PROJECT_USER_DELETE = gql(`
    mutation ProjectUserDelete($input: GqlProjectUserDeleteInput!) {
        projectUserDelete(input: $input)
    }
`);

export default function useProjectUserDelete() {
    const [mutate, { loading, error, data }] = useMutation(PROJECT_USER_DELETE, {
        refetchQueries: [PROJECT_USER_GET_ALL_WITH_ACCESS_TO_PROJECT],
    });

    const deleteProjectUser = (projectId: string, userId: string) =>
        mutate({ variables: { input: { projectId, userId } } });

    return {
        deleteProjectUser,
        loading,
        error,
        success: data?.projectUserDelete ?? false,
    };
}
